<h2 mat-dialog-title>Crear tipo documento</h2>
<form [formGroup]="addDocumentTypeForm" (ngSubmit)="addDocumentType()">
    <mat-dialog-content>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Texto</mat-label>
            <input matInput formControlName="description" type="text">
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close>Cancelar</button>
        <button type="submit" mat-flat-button
            [disabled]="!addDocumentTypeForm.valid || fetchingAddDocumentType">
            @if (fetchingAddDocumentType) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else {
            <p>Crear</p>
            }
        </button>
    </mat-dialog-actions>
</form>